import { Box } from "@mui/material";
import { ReactNode } from "react";
import { AlertCard } from "./components/AlertCard";

interface ErrorScreenProps {
  message: ReactNode;
}

export const ErrorScreen = ({ message }: ErrorScreenProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      marginY="auto"
      boxSizing="border-box"
      width="100%"
    >
      <AlertCard message={message} />
    </Box>
  );
};
